module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9_640.c5c0aea0.jpg";